import React from 'react'
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import 'assets/css/custom.css'
import './Breadcrumbs.css'

export default function Breadcrumbs() {
    const storeInfo = useSelector(state => state.menu)
    const intl = useIntl()
    const breadCrumbLength = storeInfo.breadCrumb.length - 1

    const getTitle = (title) => {
        if (!title) return ''
        // Pass title as both id and defaultMessage so dynamic strings
        // (e.g. event names) render as-is when no i18n key exists.
        return intl.formatMessage({ id: title, defaultMessage: title })
    }

    return (
        breadCrumbLength <= 0 ? <></> :
        <div>
            <Breadcrumb tag="nav" listTag="div">
                {
                    storeInfo.breadCrumb !== undefined &&
                    storeInfo.breadCrumb.map((item, index) => {
                        const titleStr = getTitle(item.title)
                        const isLast = index === breadCrumbLength

                        if (isLast) {
                            return (
                                <BreadcrumbItem active tag="span" key={index}>
                                    <span className="bc-item-last">{titleStr}</span>
                                </BreadcrumbItem>
                            )
                        } else {
                            return (
                                <BreadcrumbItem
                                    tag={Link}
                                    to={item.path === '' ? '#' : item.path}
                                    key={index}
                                >
                                    {titleStr}
                                </BreadcrumbItem>
                            )
                        }
                    })
                }
            </Breadcrumb>
        </div>
    )
}
